import React from 'react';
import '../styles/BookingSuccess.css';

function BookingSuccess({ appointmentId, onNewBooking, appointment }) {
  // 从BookingPage来的调用提供appointmentId和onNewBooking
  // 从BookingForm来的调用提供appointment完整对象
  
  // 如果是完整的appointment对象就直接使用
  let displayData = appointment;
  
  // 如果只有id，创建简化版的显示数据
  if (!displayData && appointmentId) {
    displayData = {
      id: appointmentId
    };
  }
  
  if (!displayData) {
    console.log('No appointment data received');
    return null;
  }

  // 格式化预约号，每4位添加一个空格
  const formatAppointmentId = (id) => {
    if (!id) return '';
    return id.toString().replace(/(.{4})/g, '$1 ').trim();
  };

  console.log('Displaying appointment success:', displayData);

  return (
    <div className="booking-success">
      <div className="success-header">
        <h3>预约成功</h3>
        <div className="appointment-id-container">
          <span className="appointment-id-label">预约号</span>
          <div className="appointment-id-value">{formatAppointmentId(displayData.id)}</div>
        </div>
      </div>
      
      <div className="success-details">
        {displayData.date && (
          <div className="detail-row">
            <strong>预约日期：</strong>
            <span>{displayData.date}</span>
          </div>
        )}
        {displayData.startTime && (
          <div className="detail-row">
            <strong>预约时间：</strong>
            <span>{displayData.startTime} - {displayData.endTime}</span>
          </div>
        )}
        {displayData.name && (
          <div className="detail-row">
            <strong>姓名：</strong>
            <span>{displayData.name}</span>
          </div>
        )}
        {displayData.phone && (
          <div className="detail-row">
            <strong>电话：</strong>
            <span>{displayData.phone}</span>
          </div>
        )}
        {displayData.currentSituation && (
          <div className="detail-row">
            <strong>当前现状：</strong>
            <span>{displayData.currentSituation}</span>
          </div>
        )}
        {displayData.problemToSolve && (
          <div className="detail-row">
            <strong>需要解决的问题：</strong>
            <span>{displayData.problemToSolve}</span>
          </div>
        )}
      </div>
      <div className="success-note">
        <p className="important">请保存好您的预约信息</p>
        <div className="qr-code-placeholder">
          <div className="qr-icon">
            <i className="qr-box"></i>
          </div>
          <p>扫描二维码可查询预约详情</p>
        </div>
        {onNewBooking && (
          <button onClick={onNewBooking} className="new-booking-btn">
            新的预约
          </button>
        )}
      </div>
    </div>
  );
}

export default BookingSuccess; 